<div class="bo-navigation">
  @if (!isProduction) {
    <div
      class="bo-navigation__item"
      routerLink="playground"
      routerLinkActive="active"
      [pTooltip]="'Playground'"
    >
      <i class="u-icon u-icon--star" aria-hidden="true"></i>
    </div>
  }
  @for (navItem of navItems; track navItem) {
    @if ((permissions() || []).includes(navItem.url) && !navItem.deactivated) {
      <div
        class="bo-navigation__item"
        [pTooltip]="navItem.name | translate"
        [routerLink]="navItem.url"
        routerLinkActive="active"
      >
        <i class="u-icon u-icon--{{ navItem.icon }}" aria-hidden="true"></i>
      </div>
    }
  }
</div>
